<template>
    <div v-if="showModal" class="modal-overlay">
        <div class="modal">
            <h3 class="row-space">Selecione o Bairro</h3>

            <div class="table-wrapper row-space">
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Bairro</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="bairro in bairros" :key="bairro.id" class="clickabe-row" @click="selecionarBairro(bairro)">
                            <td class="col-width-char10 center">{{ bairro.id }}</td>
                            <td>{{ bairro.nmbairro }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row-end">
                <button class="btn-small" @click="closeModal">Fechar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { genericPost } from '@/funcoes/api'; // Ajuste conforme sua função de API
import { globalStore } from '@/globals';

export default {
    props: {
        showModal: { type: Boolean, required: true },
        lsBairros: { type: Array, default: null }
    },
    emits: ['close', 'bairroSelecionado'],
    setup(props, { emit }) {
        const bairros = ref([]);

        const carregarBairros = async () => {
            if (props.lsBairros) {
                bairros.value = props.lsBairros;
            } else {
                try {
                    const response = await genericPost('/listas/bairros', {
                        idmunicipio: globalStore.idmunicipio,
                        ativo: 'S'
                    });
                    bairros.value = response || [];
                } catch (error) {
                    console.error('Erro ao carregar bairros:', error);
                }
            }
        };

        const selecionarBairro = (bairros) => {
            emit('bairroSelecionado', bairros); 
            closeModal();
        };

        const closeModal = () => {emit('close');};

        onMounted(() => {carregarBairros();});

        return { bairros, selecionarBairro, closeModal };
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: white;
    padding: 10px;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.bairro-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.bairro-table th,
.bairro-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
}

.bairro-table th {
    background: #f4f4f4;
}

.close-button:hover {
    background: #d33;
}
</style>
  